// Global counters for cache.
// See also pcbModeStats.
export const inMemoryCacheStats = {
    cacheHits: 0,
    cacheMisses: 0,
    cacheHitRate: 0,
    cacheSize: 0,
};
//# sourceMappingURL=inMemoryCacheStats.js.map